import applicationStatusConstants from 'utils/constants/statusConstants'

const defineOrder = (content) => {
  switch (content) {
    case applicationStatusConstants.OK:
      return 1
    case applicationStatusConstants.PARTIAL:
      return 2
    case applicationStatusConstants.ERROR:
      return 3
    default:
      return 0
  }
}

export const tableOptions = (loading) => {
  return {
    filter: false,
    viewColumns: false,
    search: true,
    responsive: 'simple',
    tableBodyMaxHeight: null,
    download: false,
    print: false,
    rowsPerPage: 50,
    rowsPerPageOptions: [10, 50, 100, 200, 1000],
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: loading ? 'Carregando' : 'Nenhum registro encontrado',
        toolTip: 'Ordenar',
        columnHeaderTooltip: column => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: 'Próxima página',
        previous: 'Página anterior',
        rowsPerPage: 'Registros por página:',
        displayRows: 'de',
      },
    },
    sortOrder: {
      name: 'current_status',
      direction: 'asc',
    },
    customSort: (data, colIndex, order) => {
      const invert = order === 'desc' ? 1 : -1

      return data.sort((a, b) => {
        return (
          (defineOrder(a.data[colIndex]) < defineOrder(b.data[colIndex]) ? -1 : 1) * invert
        )
      })
    },
  }
}
